import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://assets.cdn.filesafe.space/mT80PbegrbDSOV5X6nOi/media/6a86ea3267ecc8731dcf5a7b.png";
const ICON_URL =
  "https://assets.cdn.filesafe.space/mT80PbegrbDSOV5X6nOi/media/6a86ea32ad59e6cfedb1f997.png";

export const Logo: React.FC<{ className?: string; light?: boolean }> = ({
  className = "",
  light = false,
}) => {
  return (
    <Link
      to="/"
      className={`flex items-center gap-2.5 group focus:outline-none ${className}`}
    >
      <img
        src={ICON_URL}
        alt="Feingold Property Management icon"
        className="h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.05]"
      />
      <img
        src={LOGO_URL}
        alt="Feingold Property Management"
        className="h-8 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.02]"
        style={light ? { filter: "brightness(0) invert(1)" } : undefined}
      />
    </Link>
  );
};
